export default __webpack_public_path__ + "static/media/zero-cost.ec5fdf9f.png";